<template>
  <div>
    <card v-if="fuel_transactions && fuel_transactions.length > 0" ref="report" v-loading="loading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Frota - {{ lastEdition | formatDate("full") }}
        </h6>
      </div>

      <div class="col print-only">
        <img src="/img/brand/top-logo.png" class="navbar-brand-img" style="width: 200px; display:block; margin-left:auto; margin-right: auto;"/>
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Frota - {{ lastEdition | formatDate("full") }}
        </h6>
        <br />
        <br />
        <br />
      </div>
      <div v-for="(list, key) in tableData" :key="key">
        <div class="row">
          <div class="col-6">
            <h1>{{ key }}</h1>
          </div>
        </div>
        <el-table
          min-width="500px"
          :data="list"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          :summary-method="getSummaries"
          show-summary
        >
          <el-table-column
            width="300"
            label="Motorista"
            prop="driver"
            sortable
            v-slot="{ row }"
          >
            <span>{{ row.driver }}</span>
          </el-table-column>
          <el-table-column
            width="110"
            label="Placa"
            prop="license_plate"
            sortable
            v-slot="{ row }"
          >
            <span>{{ row.license_plate }}</span>
          </el-table-column>
          <el-table-column
            width="120"
            label="Utilização"
            prop="utilization_date"
            v-slot="{ row }"
            sortable
          >
            <span>{{ row.utilization_date | formatDate("short") }}</span>
          </el-table-column>
          <el-table-column
            width="155"
            label="Combustível"
            prop="fuel_type"
            v-slot="{ row }"
            sortable
          >
            <span>{{ row.fuel_type }}</span>
          </el-table-column>
          <el-table-column
            width="150"
            label="Quantidade (L)"
            prop="volume"
            v-slot="{ row }"
            sortable
          >
            <span>{{ (row.volume || 0).toLocaleString("pt-BR") }}</span>
          </el-table-column>
          <el-table-column
            width="175"
            label="Valor Unitario"
            prop="unitary_value"
            v-slot="{ row }"
            sortable
          >
            <span>{{ (parseFloat(row.unitary_value) || 0).toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}</span>
          </el-table-column>
          <el-table-column
            width="155"
            label="Valor Total"
            prop="total_value"
            v-slot="{ row }"
            sortable
          >
            <span>{{ (parseFloat(row.total_value) || 0).toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}</span>
          </el-table-column>
          <el-table-column
            width="215"
            label="Odomentro Anterior"
            prop="pedometer_before"
            sortable
            v-slot="{ row }"
          >
            <span>{{ (row.pedometer_before || 0).toLocaleString("pt-BR")}}</span>
          </el-table-column>
          <el-table-column
            width="155"
            label="Odometro"
            prop="pedometer"
            sortable
            v-slot="{ row }"
          >
            <span>{{ (row.pedometer || 0).toLocaleString("pt-BR")}}</span>
          </el-table-column>
          <el-table-column
            width="170"
            label="Km Percorrido"
            prop="km_traveled"
            sortable
            v-slot="{ row }"
          >
            <span>{{ (row.km_traveled || 0).toLocaleString("pt-BR")}}</span>
          </el-table-column>
          <el-table-column
            width="170"
            label="Média Efetiva"
            prop="average"
            v-slot="{ row }"
            sortable
          >
            <span>{{ (row.average | number).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</span>
          </el-table-column>
          <el-table-column
            width="180"
            label="Custo por KM"
            prop="cost_per_km"
            v-slot="{ row }"
            sortable
          >
            <span>
              {{
                (parseFloat(row.total_value || 0) / parseFloat(row.km_traveled || 1)).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </span>
          </el-table-column>
          <el-table-column
          width="215"
          label="Opções"
          prop="options"
          sortable
          v-slot="{ row }"
        >
        <span @click="">
          <base-button @click="editFuelTransaction(row)" type="neutral" class="ml-3" size="sm">
          Editar
        </base-button>
        </span>
        </el-table-column>
        </el-table>
        <br />
        <br />
        <br />
      </div>
    </card>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, computed, defineEmits, onMounted } from "vue";
import { Table, TableColumn } from "element-ui";
import axios from "@/backend/axios/index.js";
import Card from '@/components/Cards/Card.vue';

const props = defineProps({
  filter: Object
});

const ElTable = Table
const ElTableColumn = TableColumn

const emit = defineEmits(["edit"]);

const loading = computed({
  get: () => props.loading,
  set: (value) => emit("update:loading", value),
});

const editFuelTransaction = (fuel_transaction) => {
  emit("edit", fuel_transaction);
};

const tableData = computed(() => {
  let data = {};
  fuel_transactions.value.forEach((value) => {
    if (!value.driver) return;

    if (!data[value.driver]) data[value.driver] = [];
    data[value.driver].push(value);
  });

  return sortObject(data);
});

const sortObject = (obj) => {
  return Object.keys(obj)
    .sort()
    .reduce(function (result, key) {
      result[key] = obj[key];
      return result;
    }, {});
};

const getSummaries = (param) => {
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = "Soma";
      return;
    }
    const values = data.map((item) => Number(item[column.property]));
    if (!values.every((value) => isNaN(value))) {
      if (index === 9) {
        sums[index] = values
          .reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          });
      }
      if (index === 6) {
        sums[index] = values
          .reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          })
          .toLocaleString("pt-BR", {
            style: "currency",
            currency: "brl",
          });
      }
    } else {
      sums[index] = "";
    }
  });

  return sums;
};

const fuel_transactions = ref([]);
const lastEdition = ref({});

const generateReport = async () => {
  loading.value = true;
  try {
    const response = await axios.get("/api/v1/fuel_transactions", {
      params: {
        "filter[driver]": props.filter ? props.filter.driver_name   : null || 
                          props.filter ? props.filter.manager_name  : null,
        "filter[start_date]": props.filter ? props.filter.start_date: null,
        "filter[end_date]": props.filter ? props.filter.end_date  : null,
      },
    });
    lastEdition.value = new Date();
    fuel_transactions.value = response.data;
  } catch (error) {
    console.error("[Reports][FuelTransactions][generateReport]", error);
  } finally {
    loading.value = false;
  }
}

watch(() => props.filter, () => {
  generateReport();
});

onMounted(() => {
  setData();
  generateReport();
})

</script>

<style lang="scss">
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
.el-table__footer {
  font-weight: bold;
  width: 200px;
}
.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: overlay;
}

#fuel-usage-report-page .el-table {
  tr, td {
    text-align: center !important;
  }

  th .cell {
    display: inline-block;
    text-align: center;
    padding-top: 8px;
  }
}
</style>